import { Link, type ILink } from "@medoma/components/Link/Link";
import { getPatientNameWithStatus, type IListPatient } from "@/api/Patients";
import { patientStatusSchema } from "@medoma/models/patients";
import { Text } from "@medoma/components/Text/Text";
import TeamBadge from "@/components/Teams/TeamBadge";
import styles from "./PatientLink.module.scss";
import { FlagsPopover } from "../FlagsPopover/FlagsPopover";
import { KeyToPatientPopover } from "../KeyToPatientPopover/KeyToPatientPopover";
import { PetPopover } from "../PetPopover/PetPopover";
import { PatientResponsiblePopover } from "../PatientResponsiblePopover/PatientResponsiblePopover";

type IPatientLink = Pick<ILink, "size" | "color" | "weight"> & {
  patient: IListPatient;
};

export const PatientLink = ({
  patient,
  size = "small",
  color = "neutral",
  weight = "regular",
}: IPatientLink) => {
  // There is no patient page for deleted patients, so no link
  if (patient.status === patientStatusSchema.enum.deleted) {
    return (
      <Text element="span" size={size} weight={weight}>
        {getPatientNameWithStatus(patient, "full")}
      </Text>
    );
  }

  const hasIndicators =
    patient.flags ||
    patient.address.keyToPatient ||
    patient.pet ||
    patient.primaryResponsible;

  return (
    <div className={styles.patientLinkWrapper}>
      <Link
        to={`/commandcenter/patients/${patient.id}`}
        size={size}
        color={color}
        weight={weight}
      >
        {getPatientNameWithStatus(patient, "full")}
      </Link>
      {hasIndicators ? (
        <div className={styles.indicators}>
          {patient.flags ? <FlagsPopover details={patient.flags} /> : null}
          {patient.address.keyToPatient ? (
            <KeyToPatientPopover details={patient.address.keyToPatient} />
          ) : null}
          {patient.pet ? <PetPopover details={patient.pet} /> : null}
          {patient.primaryResponsible ? (
            <PatientResponsiblePopover
              employeeId={patient.primaryResponsible}
            />
          ) : null}
        </div>
      ) : null}
      {patient.team ? <TeamBadge team={patient.team} /> : null}
    </div>
  );
};
